define('app/views/feedback_landing_page_view',['app/setup',
  'app/collections/feedback_rate_collection'], function(takhfifan) {
  takhfifan.FeedbackLandingPageView = Backbone.View.extend({
    events: {
      'click .rate span': 'rating',
      'click .submit-form a.submit': 'submitRate',
      'keyup .input-answer textarea' : 'answering',
      'click .feedback-error .icon-close':'closeError'
    },

    initialize: function() {
      this.collection = new takhfifan.FeedbackRateCollection;
      var rate = this.getUrlParameter("rate"),
          question_id=this.getUrlParameter("q");
      // get answered question that came from email and classes to their markup
      $(".net-promoter-card[data-id='" + question_id +"']").addClass("answered").attr('data-answer',rate).find("div.your-rate span").html(rate);
      $(".net-promoter-card[data-id='" + question_id +"']").find(".rate span[data-score='" + rate +"']").addClass("passed active").prevAll().addClass("passed");

    },
    // get Rating value 1-10
    rating: function(e){
      var answer = $(e.currentTarget).data('score');
      $(e.currentTarget).parent().parent().parent().find('div.your-rate span').html(answer);
      $(e.currentTarget).parent().parent().parent().attr('data-answer',answer);
      $(e.currentTarget).parent().find('span').removeClass("passed");
      $(e.currentTarget).parent().parent().parent().addClass("answered");
      $(e.currentTarget).addClass("passed active").prevAll().addClass("passed");
    },
    // get answer question from input with keyup
    answering: function(e){
      var answer = e.target.value;
      $(e.currentTarget).parent().parent().parent().attr('data-answer',answer);
      if(answer !== "" && answer !== undefined){
        $(e.currentTarget).parent().parent().parent().addClass("answered");
      }
      else{
        $(e.currentTarget).parent().parent().parent().removeClass("answered");
      }
    },
    // get query string from url
    getUrlParameter:function(sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    },
    //close error box
    closeError :function(){
      $(".feedback-error").removeClass("show")
    },
    // post data to api via ajax
    submitRate: function (e) {
      debugger;
      var _this = this,
        survey_id = _this.getUrlParameter("id");
       var answers=[];
      $(".net-promoter-card.answered").each(function(){
        debugger;
        var id = $(this).data('id'),
          answer = $(this).data('answer');
            answers.push({
              question_id:id,
              answer:answer
            })
      });
      this.collection.rate({
        dataType: 'json',
        data: {
          form_key: takhfifan.formKey,
          "survey_id":survey_id,
          "answers":answers
        },
        success: function (collection) {
          $(".feedback-process").addClass("feedback-submited")
        },
        fail: function () {
          $('.feedback-error').addClass("show");
        },
        complete: function () {}
      })
    }

  });
});





